import { render } from "./LinkExterno.vue?vue&type=template&id=d88f0308&scoped=true"
import script from "./LinkExterno.vue?vue&type=script&lang=js"
export * from "./LinkExterno.vue?vue&type=script&lang=js"

import "./LinkExterno.vue?vue&type=style&index=0&id=d88f0308&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d88f0308"]])

export default __exports__